import React, { useState } from 'react';
import './Subscribe.css';

const Subscribe = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Email submitted:', email);
    // Reset form
    setEmail('');
  };

  return (
    <div className="subscribe-container">
      <div className="subscribe-content">
        <h2 style={{color:'#DCB15D'}} className="subscribe-title">Subscribe to our newsletters</h2>
        <p className="subscribe-description">
          Stay updated with exclusive offers, events, and the latest happenings at Nimantrana Hotel, Noida.
        </p>
      </div>
      
      <div className="subscribe-form-container">
        <form onSubmit={handleSubmit} className="subscribe-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="subscribe-input"
            required
          />
          <button type="submit" className="subscribe-button">
            Submit
          </button>
        </form>
        
        <p className="subscribe-disclaimer">
          By submitting this form, I agree to receive exclusive offers, event updates, and 
          marketing communications from Nimantrana Hotel, Noida via 
          email and phone. I understand I can unsubscribe at any time by 
          clicking the unsubscribe link. For more information on how we handle 
          your data, see our <a href="#" className="privacy-link">Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
};

export default Subscribe;